/*
 * useTreeSelections  hook
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { useCallback, useState } from "react";
import { ITreeNode } from "./TreeViewTypes";
import { ITreeViewProps } from "./TreeView";

export function useTreeSelections(
	defaultSelections: ITreeNode["id"][] = []
): [ITreeViewProps["selections"], ITreeViewProps["onNodeSelect"]] {
	const [ selections, setSelections ] = useState<ITreeNode["id"][]>(defaultSelections);

	const onNodeSelect: ITreeViewProps["onNodeSelect"] = useCallback(
		(node, { selected, isMultiselect }) => {
			setSelections((prevState) => {
				const selectedKey = node.id;

				if (selected) {
					if (isMultiselect) {
						return [ ...prevState, selectedKey ];
					}

					return [ selectedKey ];
				}

				if (isMultiselect) {
					prevState.splice(prevState.indexOf(selectedKey), 1);
					return [ ...prevState ];
				}

				return [ selectedKey ];
			});
		},
		[ setSelections ]
	);

	return [ selections, onNodeSelect ];
}
